<router-outlet />
<rr-snackbar></rr-snackbar>
<app-nomobileuse *ngIf="showmobile"></app-nomobileuse>
